/* === Nettoyage des favoris (produits supprimés du catalogue) === */
(function () {
  function getWishlistIds() {
    var name = 'apwl=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        var val = c.substring(name.length);
        return val ? val.split(',').filter(Boolean) : [];
      }
    }
    return [];
  }

  function setWishlistCookie(ids) {
    var expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = 'apwl=' + ids.join(',') + '; expires=' + expires.toUTCString() + '; path=/';
  }

  function updateWishlistCount(count) {
    document.querySelectorAll('ap-wishlistcount').forEach(function (el) {
      el.innerHTML = count;
    });
  }

  var ids = getWishlistIds();
  if (ids.length === 0) return;

  var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
  fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=20')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var existingIds = products.map(function (p) { return String(p.id); });
      var cleaned = ids.filter(function (id) { return existingIds.indexOf(id) !== -1; });
      if (cleaned.length !== ids.length) {
        setWishlistCookie(cleaned);
        updateWishlistCount(cleaned.length);
        if (window.location.pathname.indexOf('wishlist') !== -1) {
          window.location.reload();
        }
      }
    })
    .catch(function () {});
})();

/* === Vider le panier après paiement Vigneco réussi (?vigneco_paid=1) === */
(function () {
  if (new URLSearchParams(window.location.search).get('vigneco_paid') !== '1') return;
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function () {
      var url = new URL(window.location.href);
      url.searchParams.delete('vigneco_paid');
      window.history.replaceState({}, '', url.toString());
      document.querySelectorAll('ap-cartcount').forEach(function (el) { el.innerHTML = '0'; });
    })
    .catch(function () {});
})();

/* === Recherche producteurs === */
(function () {
  function openProducerSearch() {
    var overlay = document.getElementById('producer-search-overlay');
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var input = document.getElementById('producer-search-input');
      if (input) input.focus();
    }, 100);
  }

  function closeProducerSearch() {
    var overlay = document.getElementById('producer-search-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    clearProducerSearch();
  }

  function clearProducerSearch() {
    var input = document.getElementById('producer-search-input');
    var clearBtn = document.getElementById('producer-search-clear');
    if (input) {
      input.value = '';
      filterProducers('');
    }
    if (clearBtn) clearBtn.style.display = 'none';
  }

  function filterProducers(query) {
    var q = query.toLowerCase().trim();
    var cards = document.querySelectorAll('.producer-result-card');
    var noResults = document.getElementById('producer-no-results');
    var countEl = document.getElementById('producer-search-count');
    var visible = 0;
    cards.forEach(function (card) {
      var name = card.dataset.name || '';
      var region = card.dataset.region || '';
      var match = name.indexOf(q) !== -1 || region.indexOf(q) !== -1;
      card.style.display = match ? 'flex' : 'none';
      if (match) visible++;
    });
    if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    if (countEl) {
      if (q === '') {
        countEl.textContent = cards.length + ' producteur' + (cards.length > 1 ? 's' : '');
      } else {
        countEl.textContent = visible + ' résultat' + (visible > 1 ? 's' : '');
      }
    }
  }

  window.openProducerSearch = openProducerSearch;
  window.closeProducerSearch = closeProducerSearch;
  window.clearProducerSearch = clearProducerSearch;

  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('producer-search-input');
    var clearBtn = document.getElementById('producer-search-clear');

    if (input) {
      input.addEventListener('input', function () {
        filterProducers(this.value);
        if (clearBtn) clearBtn.style.display = this.value ? 'flex' : 'none';
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeProducerSearch();
    });
  });
})();

/* === Composeur de caisse === */
(function () {
  'use strict';

  var STORAGE_KEY = 'vigneco_compositions';
  var currentProducerHandle = null;
  var currentModalId = null;

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function loadAll() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function saveAll(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); }
    catch (e) {}
  }
  function loadComposition(handle) { return loadAll()[handle] || null; }
  function saveComposition(handle, comp) {
    var all = loadAll();
    if (comp === null) { delete all[handle]; } else { all[handle] = comp; }
    saveAll(all);
    updateBadges();
  }

  function countActive() {
    var all = loadAll();
    return Object.keys(all).filter(function (k) {
      return all[k] && all[k].items && all[k].items.length > 0;
    }).length;
  }

  function updateBadges() {
    var count = countActive();
    document.querySelectorAll('.composeur-badge-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.composeur-mobile-badge-text').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function getModal(modalId) {
    return document.getElementById(modalId);
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderBubbles(modal, items, bottlesPerCase) {
    var bubbles = modal.querySelectorAll('.composeur-bubble');
    bubbles.forEach(function (bubble, i) {
      var item = items[i];
      if (item) {
        bubble.classList.remove('composeur-bubble--empty');
        bubble.classList.add('composeur-bubble--filled');
        var img = bubble.querySelector('.composeur-bubble__image');
        if (img) { img.src = item.image || ''; img.alt = item.productTitle || ''; }
        bubble.setAttribute('data-product-title', item.productTitle || '');
        bubble.setAttribute('data-product-url', item.productUrl || (item.productHandle ? '/products/' + item.productHandle : ''));
      } else {
        bubble.classList.remove('composeur-bubble--filled');
        bubble.classList.add('composeur-bubble--empty');
        var img2 = bubble.querySelector('.composeur-bubble__image');
        if (img2) { img2.src = ''; img2.alt = ''; }
        bubble.removeAttribute('data-product-title');
        bubble.removeAttribute('data-product-url');
      }
    });
    var filled = modal.querySelector('.composeur-counter-filled');
    if (filled) filled.textContent = items.length;
  }

  function initBubbleTooltips(modal) {
    if (modal._bubbleTooltipInited) return;
    modal._bubbleTooltipInited = true;

    var tooltip = modal.querySelector('.composeur-bubble-tooltip');
    if (!tooltip) return;
    var ttTitle = tooltip.querySelector('.composeur-bubble-tooltip__title');
    var bubblesEl = modal.querySelector('.composeur-caisse-modal__bubbles');
    if (!bubblesEl) return;

    var currentUrl = null;
    var hideTimeout = null;

    function showTooltip(bubble) {
      clearTimeout(hideTimeout);
      var title = bubble.getAttribute('data-product-title');
      currentUrl = bubble.getAttribute('data-product-url') || null;
      if (!title) return;
      if (ttTitle) ttTitle.textContent = title;
      var rect = bubble.getBoundingClientRect();
      tooltip.style.display = 'block';
      tooltip.style.left = Math.round(rect.left + rect.width / 2) + 'px';
      tooltip.style.top = Math.round(rect.top - 8) + 'px';
    }

    function hideTooltip(delay) {
      hideTimeout = setTimeout(function () {
        tooltip.style.display = 'none';
        currentUrl = null;
      }, delay || 80);
    }

    bubblesEl.addEventListener('mouseover', function (e) {
      var bubble = e.target.closest('.composeur-bubble--filled');
      if (bubble) showTooltip(bubble);
    });

    bubblesEl.addEventListener('mouseout', function (e) {
      var bubble = e.target.closest('.composeur-bubble--filled');
      if (!bubble) return;
      if (!tooltip.contains(e.relatedTarget)) hideTooltip(80);
    });

    tooltip.addEventListener('mouseenter', function () { clearTimeout(hideTimeout); });
    tooltip.addEventListener('mouseleave', function () { hideTooltip(0); });

    tooltip.addEventListener('click', function () {
      if (currentUrl) window.open(currentUrl, '_blank');
      hideTooltip(0);
    });
  }

  function renderProductCards(modal, items, bottlesPerCase) {
    var isFull = items.length >= bottlesPerCase;
    var countById = {};
    items.forEach(function (it) {
      countById[it.variantId] = (countById[it.variantId] || 0) + 1;
    });
    modal.querySelectorAll('.composeur-product-card').forEach(function (card) {
      var btn = card.querySelector('.composeur-product-card__add-btn');
      var badge = card.querySelector('.composeur-card-count-badge');
      if (!btn) return;
      var vId = parseInt(card.getAttribute('data-variant-id'), 10);
      var cnt = countById[vId] || 0;
      card.classList.toggle('is-added', cnt > 0);

      // Badge vert — toujours "Ajouter" rouge séparé
      if (badge) {
        if (cnt > 0) {
          badge.innerHTML = '&#10003; &times;' + cnt;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      }

      // Bouton rouge toujours "Ajouter", désactivé uniquement si caisse pleine
      btn.disabled = isFull;
      btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg> Ajouter';
    });
  }

  function renderFooter(modal, items, bottlesPerCase) {
    var total = items.reduce(function (s, it) { return s + (it.price || 0); }, 0);
    var priceEl = modal.querySelector('.composeur-total-price');
    if (priceEl) priceEl.textContent = formatMoney(total);
    var btn = modal.querySelector('[data-action="confirm-caisse"]');
    if (btn) {
      btn.disabled = items.length < bottlesPerCase;
      btn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
    }
  }

  function openModal(modalId, producerHandle, producerName, bottlesPerCase, initialVariantId) {
    var modal = getModal(modalId);
    if (!modal) return;

    currentProducerHandle = producerHandle;
    currentModalId = modalId;

    var bpc = parseInt(bottlesPerCase, 10) || 6;

    // Warning: other active compositions
    var all = loadAll();
    var others = Object.keys(all).filter(function (k) {
      return k !== producerHandle && all[k] && all[k].items && all[k].items.length > 0;
    });
    var warnEl = modal.querySelector('.composeur-other-caisse-warning');
    if (warnEl) {
      if (others.length > 0) {
        var names = others.map(function (k) { return all[k].producerName || k; });
        warnEl.querySelector('.composeur-other-caisse-warning__text').textContent =
          'Vous avez une caisse en cours chez ' + names.join(', ') + '. Revenez sur un de leurs produits pour reprendre.';
        warnEl.style.display = 'flex';
      } else {
        warnEl.style.display = 'none';
      }
    }

    // Load or init composition
    var saved = loadComposition(producerHandle);
    var items = saved ? saved.items.slice() : [];

    if (items.length === 0 && initialVariantId) {
      var initCard = modal.querySelector('[data-variant-id="' + initialVariantId + '"]');
      if (initCard) {
        items.push({
          variantId: parseInt(initialVariantId, 10),
          productTitle: initCard.getAttribute('data-product-title') || '',
          price: parseInt(initCard.getAttribute('data-price'), 10) || 0,
          image: initCard.getAttribute('data-image') || '',
          productHandle: initCard.getAttribute('data-product-handle') || ''
        });
      }
    }

    var producerGid = modal.getAttribute('data-producer-gid') || '';
    if (!saved) {
      saveComposition(producerHandle, {
        producerHandle: producerHandle,
        producerName: producerName,
        bottlesPerCase: bpc,
        producerGid: producerGid,
        items: items
      });
    } else if (items.length !== saved.items.length) {
      saved.items = items;
      if (!saved.producerGid && producerGid) saved.producerGid = producerGid;
      saveComposition(producerHandle, saved);
    }

    renderBubbles(modal, items, bpc);
    renderFooter(modal, items, bpc);

    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    initBubbleTooltips(modal);
    loadProductsForModal(modal, producerHandle, bpc, items);
  }

  function loadProductsForModal(modal, producerHandle, bpc, currentItems) {
    var producerGid = modal.getAttribute('data-producer-gid');
    if (!producerGid) {
      var firstHandle = currentItems && currentItems[0] && currentItems[0].productHandle;
      if (firstHandle) {
        fetch('/products/' + firstHandle + '?sections=get-producer-gid')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var rawHtml = data['get-producer-gid'] || '';
            var doc = new DOMParser().parseFromString(rawHtml, 'text/html');
            var gid = doc.body ? doc.body.textContent.trim() : '';
            if (gid) {
              modal.setAttribute('data-producer-gid', gid);
              var comp = loadComposition(producerHandle);
              if (comp && !comp.producerGid) { comp.producerGid = gid; saveComposition(producerHandle, comp); }
              loadProductsForModal(modal, producerHandle, bpc, currentItems);
            } else {
              var pa = modal.querySelector('.composeur-caisse-modal__products');
              if (pa) pa.innerHTML = '<p class="composeur-no-products" style="padding:30px;text-align:center;">Impossible de charger les vins.<br><small>Retournez sur la fiche d\'un produit de ce domaine pour modifier la caisse.</small></p>';
            }
          })
          .catch(function () {
            var pa = modal.querySelector('.composeur-caisse-modal__products');
            if (pa) pa.innerHTML = '<p class="composeur-no-products" style="padding:30px;text-align:center;">Impossible de charger les vins.<br><small>Retournez sur la fiche d\'un produit de ce domaine pour modifier la caisse.</small></p>';
          });
        return;
      }
      var productsArea2 = modal.querySelector('.composeur-caisse-modal__products');
      if (productsArea2) productsArea2.innerHTML = '<p class="composeur-no-products" style="padding:30px;text-align:center;">Impossible de charger les vins.<br><small>Retournez sur la fiche d\'un produit de ce domaine pour modifier la caisse.</small></p>';
      return;
    }
    var productsArea = modal.querySelector('.composeur-caisse-modal__products');
    if (!productsArea) return;

    fetch('/collections/all?filter.p.m.custom.producteur=' + producerGid + '&sections=composeur-products-ajax')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rawHtml = data['composeur-products-ajax'] || '';
        var doc = new DOMParser().parseFromString(rawHtml, 'text/html');
        var inner = doc.querySelector('#shopify-section-composeur-products-ajax');
        productsArea.innerHTML = inner ? inner.innerHTML : rawHtml;
        renderProductCards(modal, currentItems, bpc);
      })
      .catch(function () {
        productsArea.innerHTML = '<p class="composeur-no-products">Impossible de charger les produits.</p>';
      });
  }

  function closeModal() {
    if (!currentModalId) return;
    var modal = getModal(currentModalId);
    if (modal) {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
    }
    document.body.style.overflow = '';
    currentProducerHandle = null;
    currentModalId = null;
  }

  function addItem(variantId, productTitle, price, image, productHandle, productUrl) {
    if (!currentProducerHandle || !currentModalId) return;
    var comp = loadComposition(currentProducerHandle);
    if (!comp) return;
    var bpc = comp.bottlesPerCase || 6;
    if (comp.items.length >= bpc) return;
    comp.items.push({ variantId: variantId, productTitle: productTitle, price: price, image: image, productHandle: productHandle, productUrl: productUrl || '' });
    // Allow duplicates — no restriction on same variant
    saveComposition(currentProducerHandle, comp);
    var modal = getModal(currentModalId);
    if (modal) {
      renderBubbles(modal, comp.items, bpc);
      renderProductCards(modal, comp.items, bpc);
      renderFooter(modal, comp.items, bpc);
    }
  }

  function removeItem(slotIndex) {
    if (!currentProducerHandle || !currentModalId) return;
    var comp = loadComposition(currentProducerHandle);
    if (!comp) return;
    comp.items.splice(slotIndex, 1);
    saveComposition(currentProducerHandle, comp);
    var modal = getModal(currentModalId);
    if (modal) {
      var bpc = comp.bottlesPerCase || 6;
      renderBubbles(modal, comp.items, bpc);
      renderProductCards(modal, comp.items, bpc);
      renderFooter(modal, comp.items, bpc);
    }
  }

  function addCompositionToCart(handle, modalId) {
    var comp = loadComposition(handle);
    if (!comp) return;
    var bpc = comp.bottlesPerCase || 6;
    if (comp.items.length < bpc) return;

    var modal = modalId ? getModal(modalId) : null;
    var confirmBtn = modal && modal.querySelector('[data-action="confirm-caisse"]');
    var isUpdate = modal && modal.getAttribute('data-mode') === 'update';
    if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = isUpdate ? 'Sauvegarde en cours…' : 'Ajout en cours…'; }

    // ID unique par caisse: garde le même lors d'une modification, génère un nouveau à la création
    var caisseId = isUpdate ? handle : handle + '__' + Date.now();

    var cartItems = comp.items.map(function (it) {
      return {
        id: it.variantId,
        quantity: 1,
        properties: {
          '_caisse_composee': caisseId,
          '_caisse_producer': comp.producerName,
          '_caisse_taille': String(comp.bottlesPerCase || 6),
          '_caisse_gid': comp.producerGid || ''
        }
      };
    });

    var svgSave = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>';
    var svgCart = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

    function resetBtn() {
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.innerHTML = isUpdate ? svgSave + ' Sauvegarder la caisse' : svgCart + ' Ajouter la caisse au panier';
      }
    }

    function doAdd() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.status || data.status !== 422) {
          saveComposition(handle, null);
          if (modal) { modal.setAttribute('aria-hidden', 'true'); modal.classList.remove('is-open'); }
          document.body.style.overflow = '';
          currentProducerHandle = null;
          currentModalId = null;
          if (isUpdate && window.location.pathname.endsWith('/cart')) {
            window.location.reload();
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('ap-cartcount').forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
          var drawer = document.querySelector('ap-cartdrawer');
          if (drawer && typeof drawer.open === 'function') {
            setTimeout(function () { drawer.open(); }, 350);
          }
        } else {
          resetBtn();
          alert(data.description || 'Erreur lors de l\'ajout au panier.');
        }
      })
      .catch(function () { resetBtn(); });
    }

    // Mode update: supprimer les anciens items AVANT d'ajouter les nouveaux
    var cartKeysAttr = modal && modal.getAttribute('data-cart-keys');
    if (isUpdate && cartKeysAttr) {
      var cartKeys;
      try { cartKeys = JSON.parse(cartKeysAttr); } catch (e) { cartKeys = []; }
      if (cartKeys.length) {
        var updates = {};
        cartKeys.forEach(function (k) { updates[k] = 0; });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function () { doAdd(); })
        .catch(function () { doAdd(); });
        return;
      }
    }

    doAdd();
  }

  function openPanel() {
    var panel = document.getElementById('composeur-panel');
    if (!panel) return;
    var all = loadAll();
    var handles = Object.keys(all).filter(function (k) {
      return all[k] && all[k].items && all[k].items.length > 0;
    });
    var listEl = panel.querySelector('.composeur-panel__list');
    if (listEl) {
      if (handles.length === 0) {
        listEl.innerHTML = '<p class="composeur-panel__empty">Aucune composition en cours.<br><small>Sur la fiche produit d\'un vigneron, cliquez sur "Composer ma caisse".</small></p>';
      } else {
        var svgResume = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>';
        listEl.innerHTML = handles.map(function (h) {
          var c = all[h];
          var filled = c.items.length;
          var total = c.bottlesPerCase || 6;
          var complete = filled >= total;
          return '<div class="composeur-panel__item">' +
            '<div class="composeur-panel__item-info">' +
              '<strong>' + escHtml(c.producerName || h) + '</strong>' +
              '<span class="composeur-panel__item-progress ' + (complete ? 'composeur-panel__item-progress--ok' : '') + '">' + filled + '/' + total + ' bouteilles</span>' +
            '</div>' +
            '<div class="composeur-panel__item-actions">' +
              '<button type="button" class="composeur-panel__resume-btn" data-handle="' + escHtml(h) + '">' + svgResume + ' Reprendre</button>' +
              (complete ? '<button type="button" class="composeur-panel__readd-btn" data-handle="' + escHtml(h) + '">Ajouter au panier</button>' : '') +
              '<button type="button" class="composeur-panel__delete-btn" data-handle="' + escHtml(h) + '" aria-label="Supprimer">×</button>' +
            '</div>' +
          '</div>';
        }).join('');
        listEl.querySelectorAll('.composeur-panel__resume-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var h = btn.getAttribute('data-handle');
            var c = loadComposition(h);
            if (!c) return;
            var bpc = c.bottlesPerCase || 6;
            var modalId = createDynamicModal(h, c.producerName || h, bpc, c.producerGid || '');
            var modalEl = document.getElementById(modalId);
            if (modalEl) {
              modalEl.setAttribute('data-mode', '');
              modalEl.removeAttribute('data-cart-keys');
              var confirmBtn = modalEl.querySelector('[data-action="confirm-caisse"]');
              if (confirmBtn) confirmBtn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Ajouter la caisse au panier';
            }
            openModal(modalId, h, c.producerName || h, bpc, null);
            closePanel();
          });
        });
        listEl.querySelectorAll('.composeur-panel__readd-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            addCompositionToCart(btn.getAttribute('data-handle'), null);
            closePanel();
          });
        });
        listEl.querySelectorAll('.composeur-panel__delete-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            saveComposition(btn.getAttribute('data-handle'), null);
            openPanel();
          });
        });
      }
    }
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
  }

  function closePanel() {
    var panel = document.getElementById('composeur-panel');
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'true');
    panel.classList.remove('is-open');
  }

  // Global event delegation
  document.addEventListener('click', function (e) {
    // Open modal
    var trigger = e.target.closest('[data-action="open-composeur"]');
    if (trigger) {
      openModal(
        trigger.getAttribute('data-modal-id'),
        trigger.getAttribute('data-producer-handle'),
        trigger.getAttribute('data-producer-name'),
        trigger.getAttribute('data-bottles-per-case'),
        trigger.getAttribute('data-initial-variant-id')
      );
      return;
    }
    // Close modal (button or backdrop)
    if (e.target.closest('[data-action="close-composeur"]') ||
        e.target.getAttribute('data-action') === 'close-composeur-backdrop') {
      closeModal();
      return;
    }
    // Click on card image or title → navigate to product page
    var cardImg = e.target.closest('.composeur-product-card__image');
    var cardTitle = e.target.closest('.composeur-product-card__title');
    if (cardImg || cardTitle) {
      var card0 = (cardImg || cardTitle).closest('.composeur-product-card');
      var url = card0 && card0.getAttribute('data-product-url');
      if (url) window.open(url, '_blank');
      return;
    }

    // Add to caisse
    var addBtn = e.target.closest('[data-action="add-to-caisse"]');
    if (addBtn) {
      var card = addBtn.closest('.composeur-product-card');
      if (card) {
        addItem(
          parseInt(card.getAttribute('data-variant-id'), 10),
          card.getAttribute('data-product-title') || '',
          parseInt(card.getAttribute('data-price'), 10) || 0,
          card.getAttribute('data-image') || '',
          card.getAttribute('data-product-handle') || '',
          card.getAttribute('data-product-url') || ''
        );
      }
      return;
    }
    // Remove from caisse (bubble)
    var removeBtn = e.target.closest('[data-action="remove-from-caisse"]');
    if (removeBtn) {
      var bubble = removeBtn.closest('.composeur-bubble');
      if (bubble) removeItem(parseInt(bubble.getAttribute('data-slot'), 10));
      return;
    }
    // Confirm (add to cart)
    var confirmBtn = e.target.closest('[data-action="confirm-caisse"]');
    if (confirmBtn && currentProducerHandle) {
      addCompositionToCart(currentProducerHandle, currentModalId);
      return;
    }
    // Modifier caisse depuis le panier
    var modifyBtn = e.target.closest('[data-action="modify-caisse"]');
    if (modifyBtn) {
      modifyCartCaisseByKey(modifyBtn.getAttribute('data-caisse-key'));
      return;
    }

    // Open panel
    if (e.target.closest('[data-action="open-composeur-panel"]')) {
      openPanel();
      return;
    }
    // Close panel
    if (e.target.closest('[data-action="close-composeur-panel"]') ||
        (e.target.id === 'composeur-panel' && !e.target.closest('.composeur-panel__inner'))) {
      closePanel();
      return;
    }
  });

  // ── Modal dynamique (pour Modifier depuis le panier) ────────────
  function createDynamicModal(producerHandle, producerName, bpc, producerGid) {
    var modalId = 'composeur-caisse-modal--dyn-' + producerHandle;
    var existing = document.getElementById(modalId);
    if (existing) {
      existing.setAttribute('data-producer-gid', producerGid || '');
      existing.setAttribute('data-mode', 'update');
      var existingBtn = existing.querySelector('[data-action="confirm-caisse"]');
      if (existingBtn) existingBtn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg> Sauvegarder la caisse';
      return modalId;
    }
    var S = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22v-9"/><path d="M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"/><path d="M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"/><path d="M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z"/></svg>';
    var bubbles = '';
    for (var i = 0; i < bpc; i++) {
      bubbles += '<div class="composeur-bubble composeur-bubble--empty" data-slot="' + i + '"><span class="composeur-bubble__empty-icon" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg></span><button type="button" class="composeur-bubble__remove" data-action="remove-from-caisse" aria-label="Retirer"><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M18 6L6 18M6 6l12 12"/></svg></button><div class="composeur-bubble__image-wrapper"><img class="composeur-bubble__image" src="" alt="" loading="lazy"></div><div class="composeur-bubble__label"></div></div>';
    }
    var el = document.createElement('div');
    el.id = modalId;
    el.className = 'composeur-caisse-modal';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('data-producer-handle', producerHandle);
    el.setAttribute('data-producer-name', producerName);
    el.setAttribute('data-bottles-per-case', String(bpc));
    el.setAttribute('data-producer-gid', producerGid || '');
    el.setAttribute('data-mode', 'update');
    el.innerHTML =
      '<div class="composeur-caisse-modal__backdrop" data-action="close-composeur-backdrop"></div>' +
      '<div class="composeur-caisse-modal__inner">' +
        '<div class="composeur-caisse-modal__header"><div class="composeur-caisse-modal__header-title">' + S + '<span>Modifier votre caisse &middot; <strong>' + escHtml(producerName) + '</strong></span></div><button type="button" class="composeur-caisse-modal__close" data-action="close-composeur" aria-label="Fermer"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>' +
        '<div class="composeur-caisse-modal__bubbles-bar"><div class="composeur-caisse-modal__bubbles">' + bubbles + '</div><div class="composeur-caisse-modal__counter" aria-live="polite"><span class="composeur-counter-filled">0</span><span class="composeur-counter-sep">/</span><span class="composeur-counter-total">' + bpc + '</span><span class="composeur-counter-label"> bouteilles</span></div></div>' +
        '<div class="composeur-caisse-modal__body">' +
          '<div class="composeur-other-caisse-warning" style="display:none;" role="alert"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg><span class="composeur-other-caisse-warning__text"></span></div>' +
          '<div class="composeur-caisse-modal__products" role="list"><div class="composeur-loading"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="composeur-loading__spinner"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Chargement des vins…</div></div>' +
          '<div class="composeur-bubble-tooltip" style="display:none;" aria-hidden="true"><span class="composeur-bubble-tooltip__title"></span><span class="composeur-bubble-tooltip__link">Voir le produit →</span></div>' +
        '</div>' +
        '<div class="composeur-caisse-modal__footer"><div class="composeur-caisse-modal__footer-total">Total : <strong class="composeur-total-price">0,00 €</strong></div><button type="button" class="composeur-caisse-modal__confirm-btn" data-action="confirm-caisse" disabled aria-disabled="true"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg> Sauvegarder la caisse</button></div>' +
      '</div>';
    document.body.appendChild(el);
    return modalId;
  }

  function modifyCartCaisseByKey(caisseKey) {
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-caisse-group="' + caisseKey + '"]'));
    if (!rows.length) return;
    var producerName = rows[0].getAttribute('data-caisse-producer') || caisseKey;
    var bpc = parseInt(rows[0].getAttribute('data-caisse-taille'), 10) || 6;
    var producerGid = rows[0].getAttribute('data-caisse-gid') || '';
    // Expand rows with qty > 1
    var items = [];
    rows.forEach(function (row) {
      var qty = parseInt(row.getAttribute('data-item-qty'), 10) || 1;
      var base = { variantId: parseInt(row.getAttribute('data-variant-id'), 10) || 0, productTitle: row.getAttribute('data-product-title') || '', price: parseInt(row.getAttribute('data-price'), 10) || 0, image: row.getAttribute('data-image') || '', productHandle: row.getAttribute('data-product-handle') || '', productUrl: row.getAttribute('data-product-url') || '' };
      for (var i = 0; i < qty; i++) items.push(Object.assign({}, base));
    });
    saveComposition(caisseKey, { producerHandle: caisseKey, producerName: producerName, bottlesPerCase: bpc, producerGid: producerGid, items: items });
    // Fermer drawer si présent
    var drawer = document.querySelector('ap-cartdrawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    // Collecter les clés à supprimer (suppression différée au moment de "Sauvegarder")
    var cartKeys = [];
    rows.forEach(function (row) { var k = row.getAttribute('data-item-key'); if (k) cartKeys.push(k); });
    // Ouvrir modal — accès direct à openModal dans ce scope
    var modalId = createDynamicModal(caisseKey, producerName, bpc, producerGid);
    var modalEl = document.getElementById(modalId);
    if (modalEl && cartKeys.length) modalEl.setAttribute('data-cart-keys', JSON.stringify(cartKeys));
    openModal(modalId, caisseKey, producerName, bpc, null);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModal(); closePanel(); }
  });

  document.addEventListener('DOMContentLoaded', function () { updateBadges(); });

  window.VignecoComposeur = { openPanel: openPanel, closePanel: closePanel, updateBadges: updateBadges, openModal: openModal };
})();

/* === Groupage visuel des caisses composées dans le panier === */
(function () {
  var SVG_CAISSE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22v-9"/><path d="M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"/><path d="M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"/><path d="M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z"/></svg>';

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function createDynamicModal(producerHandle, producerName, bpc, producerGid) {
    var modalId = 'composeur-caisse-modal--dyn-' + producerHandle;
    var existing = document.getElementById(modalId);
    if (existing) {
      existing.setAttribute('data-producer-gid', producerGid || '');
      existing.setAttribute('data-mode', 'update');
      var existingBtn = existing.querySelector('[data-action="confirm-caisse"]');
      if (existingBtn) existingBtn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg> Sauvegarder la caisse';
      return modalId;
    }
    var S = SVG_CAISSE.replace('width="14" height="14"', 'width="18" height="18"');
    var bubbles = '';
    for (var i = 0; i < bpc; i++) {
      bubbles += '<div class="composeur-bubble composeur-bubble--empty" data-slot="' + i + '">' +
        '<span class="composeur-bubble__empty-icon" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg></span>' +
        '<button type="button" class="composeur-bubble__remove" data-action="remove-from-caisse" aria-label="Retirer"><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
        '<div class="composeur-bubble__image-wrapper"><img class="composeur-bubble__image" src="" alt="" loading="lazy"></div>' +
        '<div class="composeur-bubble__label"></div>' +
      '</div>';
    }
    var el = document.createElement('div');
    el.id = modalId;
    el.className = 'composeur-caisse-modal';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('data-producer-handle', producerHandle);
    el.setAttribute('data-producer-name', producerName);
    el.setAttribute('data-bottles-per-case', String(bpc));
    el.setAttribute('data-producer-gid', producerGid || '');
    el.setAttribute('data-mode', 'update');
    el.innerHTML =
      '<div class="composeur-caisse-modal__backdrop" data-action="close-composeur-backdrop"></div>' +
      '<div class="composeur-caisse-modal__inner">' +
        '<div class="composeur-caisse-modal__header">' +
          '<div class="composeur-caisse-modal__header-title">' + S + '<span>Modifier votre caisse &middot; <strong>' + escHtml(producerName) + '</strong></span></div>' +
          '<button type="button" class="composeur-caisse-modal__close" data-action="close-composeur" aria-label="Fermer"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
        '</div>' +
        '<div class="composeur-caisse-modal__bubbles-bar">' +
          '<div class="composeur-caisse-modal__bubbles">' + bubbles + '</div>' +
          '<div class="composeur-caisse-modal__counter" aria-live="polite"><span class="composeur-counter-filled">0</span><span class="composeur-counter-sep">/</span><span class="composeur-counter-total">' + bpc + '</span><span class="composeur-counter-label"> bouteilles</span></div>' +
        '</div>' +
        '<div class="composeur-caisse-modal__body">' +
          '<div class="composeur-other-caisse-warning" style="display:none;" role="alert"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg><span class="composeur-other-caisse-warning__text"></span></div>' +
          '<div class="composeur-caisse-modal__products" role="list"><div class="composeur-loading"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="composeur-loading__spinner"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Chargement des vins…</div></div>' +
          '<div class="composeur-bubble-tooltip" style="display:none;" aria-hidden="true"><span class="composeur-bubble-tooltip__title"></span><span class="composeur-bubble-tooltip__link">Voir le produit →</span></div>' +
        '</div>' +
        '<div class="composeur-caisse-modal__footer">' +
          '<div class="composeur-caisse-modal__footer-total">Total : <strong class="composeur-total-price">0,00 €</strong></div>' +
          '<button type="button" class="composeur-caisse-modal__confirm-btn" data-action="confirm-caisse" disabled aria-disabled="true"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg> Sauvegarder la caisse</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    return modalId;
  }

  function modifyCartCaisse(producerHandle, rows) {
    if (!rows || !rows.length) return;
    var producerName = rows[0].getAttribute('data-caisse-producer') || producerHandle;
    var bpc = parseInt(rows[0].getAttribute('data-caisse-taille'), 10) || 6;
    var producerGid = rows[0].getAttribute('data-caisse-gid') || '';

    // Rebuild items — expand rows with qty > 1 (Shopify merges identical variants)
    var items = [];
    rows.forEach(function (row) {
      var qty = parseInt(row.getAttribute('data-item-qty'), 10) || 1;
      var baseItem = {
        variantId: parseInt(row.getAttribute('data-variant-id'), 10) || 0,
        productTitle: row.getAttribute('data-product-title') || '',
        price: parseInt(row.getAttribute('data-price'), 10) || 0,
        image: row.getAttribute('data-image') || '',
        productHandle: row.getAttribute('data-product-handle') || '',
        productUrl: row.getAttribute('data-product-url') || ''
      };
      for (var i = 0; i < qty; i++) items.push(Object.assign({}, baseItem));
    });

    saveComposition(producerHandle, {
      producerHandle: producerHandle,
      producerName: producerName,
      bottlesPerCase: bpc,
      producerGid: producerGid,
      items: items
    });

    // Fermer drawer si présent
    var drawer = document.querySelector('ap-cartdrawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    // Collecter les clés à supprimer (suppression différée au moment de "Sauvegarder")
    var cartKeys = [];
    rows.forEach(function (row) {
      var key = row.getAttribute('data-item-key');
      if (key) cartKeys.push(key);
    });
    var modalId = createDynamicModal(producerHandle, producerName, bpc, producerGid);
    var modalEl = document.getElementById(modalId);
    if (modalEl && cartKeys.length) modalEl.setAttribute('data-cart-keys', JSON.stringify(cartKeys));
    if (window.VignecoComposeur && typeof window.VignecoComposeur.openModal === 'function') {
      window.VignecoComposeur.openModal(modalId, producerHandle, producerName, bpc, null);
    }
  }

  function initCartCaisseGroups() {
    // Retirer les anciens headers/footers injectés
    document.querySelectorAll('.cart-caisse-injected').forEach(function (el) { el.remove(); });

    var rows = document.querySelectorAll('[data-caisse-group]');
    if (rows.length === 0) return;

    var groups = {};
    rows.forEach(function (row) {
      var key = row.getAttribute('data-caisse-group');
      if (!key) return;
      if (!groups[key]) {
        groups[key] = {
          rows: [],
          producer: row.getAttribute('data-caisse-producer') || key,
          taille: parseInt(row.getAttribute('data-caisse-taille'), 10) || 6
        };
      }
      groups[key].rows.push(row);
    });

    Object.keys(groups).forEach(function (key) {
      var g = groups[key];
      var count = g.rows.reduce(function (sum, row) {
        return sum + (parseInt(row.getAttribute('data-item-qty'), 10) || 1);
      }, 0);
      var isComplete = count >= g.taille;
      var firstRow = g.rows[0];
      var lastRow = g.rows[g.rows.length - 1];

      g.rows.forEach(function (row, i) {
        row.classList.toggle('cart-item--caisse-first', i === 0);
        row.classList.toggle('cart-item--caisse-last', i === g.rows.length - 1);
      });

      // Disable qty controls for caisse items (drawer + page)
      g.rows.forEach(function (row) {
        row.querySelectorAll('.quantity__button, .quantity__input, .ap-quantityselector__button, .cart-qty-btn').forEach(function (el) {
          el.disabled = true;
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.4';
        });
      });

      // Header
      var header = document.createElement('tr');
      header.className = 'cart-caisse-group-header cart-caisse-injected';
      header.setAttribute('role', 'row');
      header.innerHTML =
        '<td colspan="10" class="cart-caisse-group-header__cell">' +
          '<div class="cart-caisse-group-title">' +
            SVG_CAISSE +
            '<span>Caisse composée &middot; <strong>' + g.producer + '</strong></span>' +
            '<span class="cart-caisse-count ' + (isComplete ? 'cart-caisse-count--ok' : 'cart-caisse-count--warn') + '">' +
              count + '/' + g.taille +
            '</span>' +
            '<button type="button" class="cart-caisse-modify-btn" data-action="modify-caisse" data-caisse-key="' + key + '">Modifier</button>' +
          '</div>' +
          (!isComplete
            ? '<div class="cart-caisse-warning">Il manque <strong>' + (g.taille - count) + ' bouteille' + (g.taille - count > 1 ? 's' : '') + '</strong> — cette caisse ne sera pas traitée comme une commande groupée.</div>'
            : '') +
        '</td>';

      firstRow.parentNode.insertBefore(header, firstRow);

      // Footer (ligne de fermeture visuelle)
      var footer = document.createElement('tr');
      footer.className = 'cart-caisse-group-footer cart-caisse-injected';
      footer.setAttribute('role', 'row');
      footer.innerHTML = '<td colspan="10" class="cart-caisse-group-footer__cell"></td>';
      lastRow.parentNode.insertBefore(footer, lastRow.nextSibling);
    });
  }

  document.addEventListener('DOMContentLoaded', initCartCaisseGroups);
  document.addEventListener('cart:refresh', function () { setTimeout(initCartCaisseGroups, 80); });
  // Page panier — re-run après chaque update AJAX du tableau
  document.addEventListener('cart:items-updated', function () { setTimeout(initCartCaisseGroups, 80); });

  window.initCartCaisseGroups = initCartCaisseGroups;
})();

/* === Dropdown "Découvrir Les Produits" — gestion tactile mobile === */
document.addEventListener('DOMContentLoaded', function () {
  // Seulement sur les appareils touch (sans vraie souris)
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) {
    document.querySelectorAll('.adv-service-button--dropdown').forEach(function (wrapper) {
      var btn = wrapper.querySelector('a.button');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        var isOpen = wrapper.classList.contains('is-open');

        // Fermer tous les autres
        document.querySelectorAll('.adv-service-button--dropdown.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });

        if (!isOpen) {
          e.preventDefault(); // empêche la navigation, ouvre le dropdown
          wrapper.classList.add('is-open');
        }
        // Si déjà ouvert : on le ferme et on laisse naviguer (pas d'e.preventDefault)
      });
    });

    // Fermer si on clique ailleurs
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.adv-service-button--dropdown')) {
        document.querySelectorAll('.adv-service-button--dropdown.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
      }
    });
  }
});


/* === Carte produit entièrement cliquable dans les grilles === */
(function () {
  /* Zones qui gardent leur propre clic : liens, boutons, formulaire panier,
     wishlist, quickview, et la photo du producteur (qui mène à son domaine). */
  var INTERACTIVE = [
    'a', 'button', 'form', 'input', 'select', 'textarea', 'label',
    'ap-wishlistbutton', 'ap-comparebutton', 'ap-quickbuy',
    '[role="button"]', '[onclick]',
    '.service-product', '.service-add-cart', '.product-card__profile-photo-overlay'
  ].join(',');

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (!event.target || !event.target.closest) return;

    var card = event.target.closest('product-item[data-product-url]');
    if (!card) return;
    if (event.target.closest(INTERACTIVE)) return;

    /* Pas de navigation pendant une sélection de texte */
    var selection = window.getSelection ? String(window.getSelection()) : '';
    if (selection.length > 0) return;

    var url = card.getAttribute('data-product-url');
    if (!url) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  });
})();


/* === Popup producteur (fiche produit « En savoir plus » + photo des cartes) === */
(function () {
  function lightboxOpen() {
    return typeof window.vgcProducerLightboxIsOpen === 'function'
      && window.vgcProducerLightboxIsOpen();
  }

  function openModal(modal) {
    if (!modal) return;
    /* Une popup imbriquée dans une carte serait rognée par les overflow /
       transform des ancêtres : on la déplace sous <body> au premier usage. */
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.style.display = 'none';
    if (!lightboxOpen()) document.body.style.overflow = 'auto';
  }

  function openModals() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.producer-modal'),
      function (m) { return m.style.display === 'flex'; }
    );
  }

  /* Compatibilité : la fiche produit exposait ces deux fonctions globales */
  window.openProducerModal = function (id) {
    openModal(document.getElementById(id || 'producer-modal'));
  };
  window.closeProducerModal = function (id) {
    if (id) closeModal(document.getElementById(id));
    else openModals().forEach(closeModal);
  };

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    /* Ouverture */
    var trigger = event.target.closest('[data-producer-open]');
    if (trigger) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      var wanted = trigger.getAttribute('data-producer-open');
      var target;
      if (wanted === 'closest') {
        /* Popup de la carte courante (ids dupliqués d'une grille à l'autre).
           On remonte jusqu'à la carte entière : la popup est rendue à la fin
           de <product-item>, donc en dehors de .product-item-wrapper. */
        var host = trigger.closest('product-item')
          || trigger.closest('.card-wrapper')
          || trigger.closest('.product-item-wrapper');
        target = host ? host.querySelector('.producer-modal') : null;
        if (!target && host && host.id) {
          var hostId = host.id.replace('product-item-', '');
          target = document.getElementById('producer-modal-' + hostId);
        }
      } else {
        target = document.getElementById(wanted);
      }
      if (target) {
        event.preventDefault();
        event.stopPropagation();
        openModal(target);
        return;
      }
    }

    /* Fermeture par la croix */
    var closer = event.target.closest('[data-producer-close]');
    if (closer) {
      event.preventDefault();
      closeModal(closer.closest('.producer-modal'));
      return;
    }

    /* Fermeture au clic sur le fond.
       Jamais sur une vignette de galerie (elle ouvre la visionneuse), jamais
       sur la visionneuse elle-même, jamais à l'intérieur d'une popup : le test
       est structurel (contains) et non par sélecteur, car les ids des popups
       de cartes sont dupliqués — chaque produit est rendu deux fois. */
    if (lightboxOpen()) return;
    if (event.target.closest('#producer-lightbox')) return;
    if (event.target.closest('.producer-photo__item')) return;

    var content = event.target.closest('.producer-modal__content');
    openModals().forEach(function (modal) {
      if (!content || !modal.contains(content)) closeModal(modal);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || lightboxOpen()) return;
    openModals().forEach(closeModal);
  });
})();
